import styled from 'styled-components';

export const EditEmployeeQuestionnaireSettingWrapper = styled.div`
  & > div:first-child {
    height: 100%;
  }
  height: 100%;

  .ant-form {
    height: 100%;
  }

  .ant-form-item {
    width: 288px;
  }
  .upload-file-field {
    width: 340px;
  }
`;

export const HeaderFormContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
`;

export const FormBodyContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

export const PreviewListContainer = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  max-height: 62vh;
  height: 100%;
  border-right: 1px solid ${({ theme }) => theme.colors.grayVariations.medium};
`;

export const AcceptedListContainer = styled.div`
  display: flex;
  position: relative;
  flex-direction: column;
  max-height: 62vh;
  height: 100%;
`;

export const ListContainer = styled.div`
  display: flex;
  flex-direction: column;
  overflow: auto;
  ${({ selectedItem }: { selectedItem?: boolean }) => selectedItem && `padding-bottom: 72px;`};
`;

export const FieldContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  max-width: 1200px;
  column-gap: 8px;
  .ant-upload-select {
    height: 40px;
    & > span {
      & > div {
        & > div {
          padding: 8px 0;
        }
      }
    }
  }
`;

export const ListWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  overflow: auto;
  height: 100%;
  border-top: 1px solid ${({ theme }) => theme.colors.grayVariations.medium};
  margin: 0 -18px;
`;
